import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function PrivateRoute({ children }) {
  const authCtx = useContext(AuthContext);
  if (authCtx.userId)
    return authCtx.isAuthenticated ? children : <Navigate to="/login" />;
  else {
    return (
      <div>
        <p>Cargando...</p>
      </div>
    );
  }
}

export default PrivateRoute;
